import React from 'react';
import { Icon } from './Icon.js';
export const IconCarDoorBack = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20.6211 11H3.00001", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 3L10 3C16.0751 3 21 7.92487 21 14C17.9081 14.6184 15.3846 16.8461 14.3875 19.8374L14 21L3 21L3 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13 15H12", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCarDoorBack.js.map